import { useQuery } from '@tanstack/react-query';
import { Dispatch } from 'redux';

import { requestHandler } from '../../api';
import {
  AutomaticCollectionNotificationDetails,
  GetAutomaticCollectionNotificationsResponse,
} from './types';

export const getAutomaticCollectionNotifications = async (
  dispatch: Dispatch,
  query: string,
): Promise<GetAutomaticCollectionNotificationsResponse | undefined> => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/collection/notifications/automatic-flow?${query}`,
    dispatch,
  });
  if (response) return response.data;
};

export const getAutomaticCollectionNotificationDetails = (
  dispatch: Dispatch,
  id: number | null,
) =>
  useQuery({
    queryKey: ['collectionNotifications', 'automatic-flow', id],
    queryFn: async (): Promise<
      AutomaticCollectionNotificationDetails | undefined
    > => {
      if (id === null) return undefined;
      const response = await requestHandler({
        method: 'get',
        url: `internal/collection/notifications/automatic-flow/${id}`,
        dispatch,
      });
      if (response) return response.data;
    },
    retry: 1,
    enabled: !!id,
    staleTime: 1000 * 60 * 30,
    gcTime: 1000 * 60 * 30,
  });

export const getAutomaticCollectionNotificationsForMonth = async (
  dispatch: Dispatch,
  month: string,
  queryParams: any,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/collection/notifications/automatic/${month}?${queryParams}`,
    dispatch,
  });
  if (response) return response.data;
};

export const getManualCollectionNotificationsForMonth = async (
  dispatch: Dispatch,
  month: string,
  queryParams: string,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/collection/notifications/manual/${month}?${queryParams}`,
    dispatch,
  });
  if (response) return response.data;
};

export const getDocumentById = async (documentId: string) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/collection/document/${documentId}`,
  });
  if (response) return response.data;
};

export const getAvailableUsersForSearch = async (dispatch: Dispatch) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/collection/available/collectors/search`,
    dispatch,
  });
  if (response) return response.data;
};
